import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=06a11850&"
import script from "./InfoBlock.vue?vue&type=script&lang=js&"
export * from "./InfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports